import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

import BgImage from '../assets/intro.png';
import useStyles from '../common/styles';

const koParagraphs = [
  '입력해주신 정보 확인 후 곧 대회 운영 사무국에서 유선(전화) RSVP가 진행 될 예정입니다.',
  '번거로우시더라도 운영 사무국 담당자와 입력하신 최종 정보 확인 부탁드립니다.',
  '가야CC에서 뵙겠습니다.',
];

const enParagraphs = [
  'After reviewing the information you submitted, the tournament operations office will contact you soon for RSVP confirmation by phone.',
  'We kindly ask for your cooperation in confirming your final details with the operations office representative.',
  'We look forward to seeing you at Gaya CC.',
];

function Done() {
  const classes = useStyles();
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only('xs'));

  return (
    <div className={classes.paper}>
      <Container maxWidth="xs">
        <img src={BgImage} alt="event identity" style={{ width: '100%' }} />
      </Container>

      <Card className={classes.form}>
        <CardContent>
          <Stack spacing={2}>
            <Stack spacing={isXs ? 1.25 : 1.5}>
              {koParagraphs.map((text) => (
                  <Typography key={text} variant="body1" sx={{ lineHeight: 1.75, textAlign: 'justify', textAlignLast: 'left', wordBreak: 'break-all' }}>
                  {text}
                </Typography>
              ))}
            </Stack>

            <Divider />

            <Stack spacing={isXs ? 1.25 : 1.5}>
              {enParagraphs.map((text) => (
                  <Typography key={text} variant="body2" sx={{ lineHeight: 1.75, textAlign: 'justify', textAlignLast: 'left' }}>
                  {text}
                </Typography>
              ))}
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    </div>
  );
}

export default Done;
